import { Badge, SimpleFlexbox } from 'ctm-components';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { pageContext } from 'ctm-util-functions';
import moment from 'moment';
import { getFormValue } from '../../core/state_selectors';
import { useStyles } from './styles';

const DriverLicenceType = () => {
    const licenceTypes = [
        {
            value: 'FULL',
            innerLabel: 'Full / Open Licence',
            labelType: 'innerLabel',
            labelKey: 'label',
            valueKey: 'code',
            variant: 'size_xs_100_sm_33',
            onClickActions: [
                { type: 'SET_VALUE', identifier: 'coverDetail.driver.licenceType', stateKey: 'vertical.quote' },
                { type: 'SET_VALUE', identifier: 'helpers.isDisclaimerContentExpanded', value: false, stateKey: 'vertical.quote' }
            ]
        },
        {
            value: 'PROVISIONAL2',
            innerLabel: 'Provisional 2 (Green)',
            labelType: 'innerLabel',
            labelKey: 'label',
            valueKey: 'code',
            variant: 'size_xs_50_sm_20',
            onClickActions: [
                { type: 'SET_VALUE', identifier: 'coverDetail.driver.licenceType', stateKey: 'vertical.quote' },
                { type: 'SET_VALUE', identifier: 'helpers.isDisclaimerContentExpanded', value: false, stateKey: 'vertical.quote' }
            ]
        },
        {
            value: 'PROVISIONAL1',
            innerLabel: 'Provisional 1 (Red)',
            labelType: 'innerLabel',
            labelKey: 'label',
            valueKey: 'code',
            variant: 'size_xs_50_sm_20',
            onClickActions: [
                { type: 'SET_VALUE', identifier: 'coverDetail.driver.licenceType', stateKey: 'vertical.quote' },
                { type: 'SET_VALUE', identifier: 'helpers.isDisclaimerContentExpanded', value: false, stateKey: 'vertical.quote' }
            ]
        },
        {
            value: 'LEARNERS',
            innerLabel: 'Learners',
            labelType: 'innerLabel',
            labelKey: 'label',
            valueKey: 'code',
            variant: 'size_xs_50_sm_20',
            onClickActions: [
                { type: 'SET_VALUE', identifier: 'coverDetail.driver.licenceType', stateKey: 'vertical.quote' },
                { type: 'SET_VALUE', identifier: 'helpers.isDisclaimerContentExpanded', value: false, stateKey: 'vertical.quote' }
            ]
        },
        {
            value: 'FOREIGN',
            innerLabel: 'Foreign Licence',
            labelType: 'innerLabel',
            labelKey: 'label',
            valueKey: 'code',
            variant: 'size_xs_50_sm_20',
            onClickActions: [
                { type: 'SET_VALUE', identifier: 'coverDetail.driver.licenceType', stateKey: 'vertical.quote' },
                { type: 'SET_VALUE', identifier: 'helpers.isDisclaimerContentExpanded', value: false, stateKey: 'vertical.quote' }
            ]
        }
    ];

    const brandCode = process.env.EVEREST_THEME?.trim();

    const classes = useStyles({ brandCode });

    const pageName = pageContext.getProps().pageState.pageName;

    const dispatch = useDispatch();
    const updateState = (licenceValue) => {
        dispatch({
            type: 'SET_VALUE',
            identifier: getPageData(pageName).componentIdentifier,
            stateKey: 'vertical.quote',
            value: licenceValue
        });
    };

    const getPageData = (pagename) => {
        let nextPageName;
        let componentIdentifier;
        let componentStateKey;
        let driverDob;

        switch (pagename) {
            case 'regular_driver_licence_type':
                nextPageName = 'regular_driver_licence_age';
                componentIdentifier = 'coverDetail.driver.licenceType';
                componentStateKey = 'vertical.quote.form.coverDetail.driver.licenceType';
                driverDob = 'coverDetail.driver.dob';
                break;
            case 'youngest_driver_licence_type':
                nextPageName = 'youngest_driver_licence_age';
                componentIdentifier = 'coverDetail.youngestDriver.licenceType';
                componentStateKey = 'vertical.quote.form.coverDetail.youngestDriverLicenceType';
                driverDob = 'coverDetail.youngestDriver.dob';
                break;
            default:
                throw new Error(`Unknown page name: ${pagename}`);
        }

        return {
            nextPageName,
            componentIdentifier,
            componentStateKey,
            driverDob
        };
    };

    const getDriverDob = useSelector((state) => getFormValue(state, getPageData(pageName).driverDob));
    const yearDifference = moment().diff(moment(getDriverDob, 'YYYY-MM-DD'), 'years');

    if (yearDifference < 18 && licenceTypes[0].value === 'FULL') {
        licenceTypes.shift(); // Business rule: Remove 'Full / Open Licence' if driver is less than 18 years old
    }

    const value = useSelector((state) => getFormValue(state, getPageData(pageName).componentIdentifier));

    return (
        <SimpleFlexbox className={classes.mainContainer}>
            {licenceTypes.map((licence) => {
                return (
                    <NavLink
                        className={classes.buttonLink}
                        id={`${pageName}_${licence.value}`}
                        data-testid={`${pageName}_${licence.value}`} // pageName either regularDriverLicenceType or youngersDriverLicenceType
                        to={`/car-insurance/journey/${getPageData(pageName).nextPageName}`} // nextPageName either regular_driver_licence_age or youngest_driver_licence_age
                        key={licence.value}
                        onClick={() => updateState(licence.value)}
                    >
                        <Badge
                            id={licence.value}
                            key={licence.value}
                            optionProps={{
                                innerLabel: licence.innerLabel,
                                value: licence.value
                            }}
                            schema={{
                                identifier: getPageData(pageName).componentIdentifier,
                                stateKey: getPageData(pageName).componentStateKey,
                                variant: 'center',
                                field: {
                                    type: 'badgegroup',
                                    metaType: 'radio',
                                    UIComponent: 'badge_primary_semi_rounded',
                                    labelVariant: 'inner_label_container_small_align_center',
                                    values: licenceTypes
                                }
                            }}
                            value={value}
                        />
                    </NavLink>
                );
            })}
        </SimpleFlexbox>
    );
};

export { DriverLicenceType };
